"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _NotificationUserGroupModel = _interopRequireDefault(require("../../models/NotificationUserGroupModel"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _AppSelect = _interopRequireDefault(require("../../../../components/crud/AppSelect"));

var _GroupConditions = _interopRequireDefault(require("../components/GroupConditions"));

var _SelectSpecificUsers = _interopRequireDefault(require("../components/SelectSpecificUsers"));

var _admin = require("@launchpad/admin");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var UserGroupForm = /*#__PURE__*/function (_Component) {
  _inherits(UserGroupForm, _Component);

  function UserGroupForm(props) {
    var _this;

    _classCallCheck(this, UserGroupForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserGroupForm).call(this, props));
    var modelData = {
      id: _this.props.id,
      name: "",
      description: "",
      isTestGroup: false,
      filterType: "conditions",
      userIds: [],
      filter: {
        createdFrom: "",
        createdTo: "",
        lastActivityFrom: "",
        lastActivityTo: "",
        balanceFrom: "",
        balanceTo: "",
        cardNotOrdered: null,
        cardNotActivated: null,
        lastTransactionFrom: "",
        lastTransactionTo: ""
      }
    };

    if (props.record) {
      modelData = _objectSpread({}, modelData, {}, props.record);
    } // Initial state


    _this.formHandler = new _admin.FormHandler(_assertThisInitialized(_this), new _NotificationUserGroupModel["default"](modelData));
    return _this;
  }

  _createClass(UserGroupForm, [{
    key: "_getFilterOptions",
    value: function _getFilterOptions() {
      return [{
        id: "conditions",
        name: "Specific conditions"
      }, {
        id: "specific_users",
        name: "Specific users"
      }];
    }
  }, {
    key: "_getFilterElement",
    value: function _getFilterElement() {
      var _this2 = this;

      switch (this.state.record.filterType) {
        case "conditions":
          return _react["default"].createElement(_GroupConditions["default"], {
            record: this.state.record,
            formHandler: this.formHandler
          });

        case "specific_users":
          return _react["default"].createElement(_SelectSpecificUsers["default"], {
            userIds: this.state.record.userIds,
            onChange: function onChange(userIds) {
              return _this2.formHandler.handleInputChange("userIds", userIds);
            }
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var formHandler = this.formHandler;
      return _react["default"].createElement("div", {
        className: "add-new-group",
        style: {
          width: "100%",
          paddingBottom: "40px"
        }
      }, _react["default"].createElement(_admin.FormSubmitWrapper, {
        formHandler: formHandler,
        to: "/user-groups"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-5"
      }, _react["default"].createElement("h3", null, "Basic Info"), _react["default"].createElement("hr", null), _react["default"].createElement(_admin.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        customInput: _TextField["default"],
        label: "Name",
        type: "text",
        name: "name",
        value: this.state.record.name,
        handler: formHandler
      }), _react["default"].createElement(_admin.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        customInput: _TextField["default"],
        label: "Description",
        type: "text",
        name: "description",
        value: this.state.record.description,
        handler: formHandler
      }), _react["default"].createElement(_admin.AppCheckboxInput, {
        name: "isTestGroup",
        value: this.state.record.isTestGroup,
        handler: this.formHandler,
        labelText: "Is testing group"
      })), _react["default"].createElement("div", {
        className: "col-md-6 col-md-offset-1 user-group-filters"
      }, _react["default"].createElement(_AppSelect["default"], {
        textFieldProps: {
          label: "Filter users",
          InputLabelProps: {
            shrink: true
          }
        },
        options: this._getFilterOptions(),
        name: "filterType",
        value: this.state.record.filterType,
        handler: formHandler,
        placeholder: "-filter type-"
      }), this._getFilterElement()))));
    }
  }, {
    key: "_getOldForm",
    value: function _getOldForm() {
      return _react["default"].createElement("div", {
        className: "add-user-group-container"
      }, _react["default"].createElement("div", {
        className: "user-group-input-wrapper"
      }, _react["default"].createElement("div", null, _react["default"].createElement("label", {
        htmlFor: "title"
      }, "Group Name"), _react["default"].createElement("input", {
        type: "text",
        id: "title",
        placeholder: ""
      })), _react["default"].createElement("div", null, _react["default"].createElement("label", {
        htmlFor: "title"
      }, "Created From"), _react["default"].createElement("input", {
        type: "text",
        id: "title",
        placeholder: ""
      })), _react["default"].createElement("div", null, _react["default"].createElement("label", {
        htmlFor: "title"
      }, "Created To"), _react["default"].createElement("input", {
        type: "text",
        id: "title",
        placeholder: ""
      }))), _react["default"].createElement("div", {
        className: "user-group-input-wrapper"
      }, _react["default"].createElement("div", null, _react["default"].createElement("label", {
        htmlFor: "title"
      }, "Balance From"), _react["default"].createElement("input", {
        type: "text",
        id: "title",
        placeholder: ""
      })), _react["default"].createElement("div", null, _react["default"].createElement("label", {
        htmlFor: "title"
      }, "Balance To"), _react["default"].createElement("input", {
        type: "text",
        id: "title",
        placeholder: ""
      })), _react["default"].createElement("div", null, _react["default"].createElement("label", {
        htmlFor: "title"
      }, "Supports School"), _react["default"].createElement("input", {
        type: "text",
        id: "title",
        placeholder: ""
      })), _react["default"].createElement("div", null, _react["default"].createElement("label", {
        htmlFor: "title"
      }, "Supports Project"), _react["default"].createElement("input", {
        type: "text",
        id: "title",
        placeholder: ""
      })), _react["default"].createElement("div", null), _react["default"].createElement("button", {
        type: "submit"
      }, "Save")));
    }
  }]);

  return UserGroupForm;
}(_react.Component);

exports["default"] = UserGroupForm;